<template>
  <transaction-user-list
    :transactionService = transactionService
  ></transaction-user-list>
</template>
<script>
  import TransactionUserList from '@/components/Common/TransactionUser/TransactionUserList'
  import transactionService from '@/services/licensor/transaction'

  export default {
    components: {
      TransactionUserList
    },
    data () {
      return {
        transactionService: transactionService,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/TransactionUsers/Overview.vue